<template>
    <div class="testimonial">
        <div class="text-warning">
            <span v-for="index in 5" :key="index">
                <i v-if="index <= testimonial.grade" class="fas fa-star"></i>
                <i v-else class="far fa-star"></i>
            </span>
        </div>
        <!--Content-->
        <h4 class="font-weight-bold dark-grey-text mt-2">{{testimonial.title}}</h4>
        <p class="font-weight-normal dark-grey-text">
          <i class="fas fa-quote-left pr-2"></i>{{testimonial.content}}</p>
        <small>{{testimonial.customer}} ({{testimonial.date.toLocaleDateString("sv")}})</small>
        <!--Review-->
      </div>
</template>

<script>
export default {
    name:"TestimonialCard",
    props:["testimonial"]
}
</script>

<style>
    .testimonial{
        padding: 1rem;
        border-radius: 5px;
        width: 50%;
        margin: 1.5rem auto;
        box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
    }
</style>